import { Metric } from "web-vitals";

/**
 * web-vitals 6 replaced the get*() API with on*() and dropped FID entirely in
 * favour of INP (Interaction to Next Paint), which superseded it as a Core Web
 * Vital. ReportHandler is likewise gone; the callback now takes a Metric.
 */
const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
